// extracted by mini-css-extract-plugin
export default {"hero-banner":"styles_hero-banner__Hd7xA","top-banner":"styles_top-banner__61c2R","logo":"styles_logo__HSi56","navigation-icons":"styles_navigation-icons__3g3Dy"};